import{Tab as r}from"./tab.js";/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */class o extends r{constructor(){super(...arguments),this.fullWidthIndicator=!0}}export{o as SecondaryTab};
